<script setup lang="ts">
import HSForm from '~/components/forms/HSForm.vue'

withDefaults(
  defineProps<{
    formId: string
    title?: string | null
    withCloseButton?: boolean
  }>(),
  {
    withCloseButton: true,
    title: null,
  },
)
</script>

<template>
  <HSForm
    class="h-full"
    :form-id="formId"
    :with-close-button="withCloseButton"
    @close="$emit('close')"
  >
    <template #header>
      <slot name="header" />
      <h5 v-if="title" class="text-lg font-semibold mb-3">{{ title }}</h5>
      <p class="ml-auto w-fit text-xxs">
        Fields marked <span class="text-error">*</span> are required
      </p>
    </template>
  </HSForm>
</template>

<style>
.bm-custom-form .hs-submit {
  margin-top: auto;
}
</style>
